<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">动态管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>类型：</label>
          <el-select v-model="reveal" placeholder="请选择" style="width: 7em;">
            <el-option v-for="item in revealArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="type" placeholder="请选择" style="width: 7em;margin-left: 4px;" v-show="reveal === 0">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>动态状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>用户状态：</label>
          <el-select v-model="resumeState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in resumeStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>置顶状态：</label>
          <el-select v-model="topState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in topStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <label>隐藏用户：</label>
          <el-select v-model="hideState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in hideStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>优质动态：</label>
          <el-select v-model="qualityState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in qualityStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>异常用户：</label>
          <el-select v-model="abnormalState" placeholder="Select" style="width: 7em">
            <el-option v-for="item in abnormalStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>删除状态：</label>
          <el-select v-model="isDel" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in isDelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>关注类型：</label>
          <el-select v-model="focusState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in focusStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>
          <el-button type="primary" @click="batchPassUpdate()">批量通过</el-button>
          <el-button type="danger"  @click="batchUpdate(2)" v-loading="batchLoading">批量不通过</el-button>
          <el-button type="warning"  @click="batchUpdate(3)" v-loading="batchLoading">仅作者可见</el-button>
          <el-button type="primary" @click="batchUpdateQuality(1)" v-loading="updateLoading">设为优质</el-button>
          <el-button type="danger"  @click="batchUpdateQuality(2)" v-loading="updateLoading">取消优质</el-button>
          <el-button type="warning" @click="updateFocusState(5)" v-loading="focusLoading">设为关注</el-button>
          <el-button type="success" @click="updateFocusState(3)" v-loading="focusLoading">取消关注</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
            :row-key="rowKey"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor" :reserve-selection="true"/>
          <el-table-column property="createTime" label="时间" v-if="checkColList.indexOf('时间') > -1" width="100"/>
          <el-table-column property="id" label="动态序号" v-if="checkColList.indexOf('动态序号') > -1" width="90"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="110">
            <template #default="scope">
              <el-image
                  style="width: 80px; height: 80px"
                  :src="scope.row.headImg.smallHeadImg"
                  @click="showImg(scope.row)"
                  class="cursor"
              >
              <template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="190">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
            </template>
          </el-table-column>
          <el-table-column property="msg" label="内容" v-if="checkColList.indexOf('内容') > -1" min-width="240"/>
          <el-table-column property="" label="图片" v-if="checkColList.indexOf('图片') > -1" width="230">
            <template #default="scope">
              <el-space wrap>
                <div v-for="(item, index) in scope.row.zoneImgList" :key="item.id" class="imgItem">
                  <el-image style="width: 60px; height: 60px" fit="cover"  :src="item.smallImg" @click="showZoneImg(index, scope.row.zoneImgList)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                  <div class="closeBtn" @click="delImg(item.id, scope.$index, index)">
                    <i class="fa fa-times" aria-hidden="true"></i>
                  </div>
                </div>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column property="" label="视频" v-if="checkColList.indexOf('视频') > -1" width="80">
            <template #default="scope">
              <i v-if="scope.row.type == 4" class="fa fa-play-circle fa-4x playBtn" aria-hidden="true" @click="onPlay(scope.row.videoId)"></i>
            </template>
          </el-table-column>
          <el-table-column label="用户状态" v-if="checkColList.indexOf('用户状态') > -1" width="90">
            <template #default="scope">
              <p>{{scope.row.resumeState == 0?'未提交':scope.row.resumeState == 1?'待审核':scope.row.resumeState == 2?'已通过':scope.row.resumeState == 3?'不通过 ':''}}</p>
              <p :style="{color:scope.row.focusState > 3?'red':'#aaaaaa' }">{{
                  scope.row.focusState == 0?'未关注':
                  scope.row.focusState == 1?"已关注":
                  scope.row.focusState == 2?"自动取消关注":
                  scope.row.focusState == 3?"手动取消关注":
                  scope.row.focusState == 4?"已关注-封号":
                  scope.row.focusState == 5?"已关注-手动":
                  scope.row.focusState == 6?"已关注-设备异常":
                  scope.row.focusState == 7?"已关注-IP异常":
                  scope.row.focusState == 8?"已关注-订单异常":
                  scope.row.focusState == 9?"已关注-省份不一致":""
                }}</p>
            </template>
          </el-table-column>
          <el-table-column label="类型" v-if="checkColList.indexOf('类型') > -1" width="90">
            <template #default="scope">
              <p>{{ scope.row.reveal == 0 ? '公开动态/' + scope.row.anonymous == 1 ? '匿名动态' : scope.row.type == 2 ? '相册动态' : '普通动态' : scope.row.reveal == 1 ? '私密动态' : '--' }}</p>
            </template>
          </el-table-column>
          <el-table-column label="动态状态" v-if="checkColList.indexOf('动态状态') > -1" width="90">
            <template #default="scope">
              <p>{{ scope.row.state == 0 ? '待审核' : scope.row.state == 1 ? '已通过' : scope.row.state == 2 ? '不通过' : scope.row.state == 3 ? '仅发布者可见' : '--' }}</p>
              <p v-if="scope.row.qualityState==1" style="color: #5daf34">优质动态</p>
              <p v-if="scope.row.qualityState==2" style="color: #ff5e5e">取消优质-系统</p>
              <p v-if="scope.row.qualityState==3" style="color: #ff5e5e">取消优质-用户</p>
              <p style="color: red;" v-if="scope.row.isDel == 1">已删除</p>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
          <el-table-column prop="topicName" label="话题" v-if="checkColList.indexOf('话题') > -1" width="90"></el-table-column>
          <el-table-column prop="" label="置顶" v-if="checkColList.indexOf('置顶') > -1" width="160">
            <template #default="scope">
              <p>置顶状态：{{ scope.row.topState == 0 ? '未置顶' : scope.row.topState == 1 ? '已置顶' : scope.row.topState == 2 ? '已过期' : '' }}</p>
              <p>置顶列表：{{ scope.row.topType == 0 ? '全部' : scope.row.topType == 1 ? '最新' : scope.row.topType == 2 ? '最热' : '' }}</p>
              <p>消息推送：{{ scope.row.topPush == 0 ? '不推送' : scope.row.topPush == 1 ? '推送' : '' }}</p>
              <p>置顶时间：{{ scope.row.topStartTime }}<span style="margin: 0 8px;" v-if="scope.row.topStartTime">至</span>{{ scope.row.topEndTime }}</p>
              <el-button type="primary" size="small" @click="setTop(scope.row, scope.$index)">置顶设置</el-button>
            </template>
          </el-table-column>
<!--          <el-table-column prop="" label="置顶列表" min-width="200px" v-if="checkColList.indexOf('置顶列表') > -1" width="90">-->
<!--            <template #default="scope">-->
<!--              <p>{{ scope.row.topType == 0 ? '全部' : scope.row.topType == 1 ? '最新' : scope.row.topType == 2 ? '最热' : '' }}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="top_time" label="置顶时间" width="90" v-if="checkColList.indexOf('用户日志') > -1">-->
<!--            <template #default="scope">-->
<!--              <div v-if="scope.row.topStartTime">-->
<!--                <p>{{ scope.row.topStartTime }}</p>-->
<!--                <p>至</p>-->
<!--                <p>{{ scope.row.topEndTime }}</p>-->
<!--              </div>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="" label="消息推送" v-if="checkColList.indexOf('消息推送') > -1" width="90">-->
<!--            <template #default="scope">-->
<!--              <p>{{ scope.row.topPush == 0 ? '不推送' : scope.row.topPush == 1 ? '推送' : '' }}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="" label="操作" width="100" v-if="checkColList.indexOf('操作') > -1">-->
<!--            <template #default="scope">-->
<!--              <el-button type="text" size="small" @click="setTop(scope.row, scope.$index)">置顶设置</el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column prop="resume.remark" label="备注" min-width="200px" v-if="checkColList.indexOf('备注') > -1"></el-table-column>-->
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getZonePageList, updateZoneState, updateZoneImgDel, updateQualityZoneState, updateResumeFocusState
} from '../../api/url'
import { getFormData, deleteFormData, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import VideoPlay from "@/components/VideoPlay";
import {common} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import SendSystemMessageChat from "@/components/SendSystemMessageChat";
import SetQualityDialog from "@/views/dynamic/components/SetQualityDialog";
import ZoneSetTopDialog from "@/views/dynamic/components/ZoneSetTopDialog";
import BatchPassDialog from "@/views/dynamic/components/BatchPassDialog";

export default {
  name: "DynamicReview",
  components: { DatePickerRange, SearchComponents, UserLog },
  data() {
    return {

      revealArray: [
        {label: '不限', value: -1},
        {label: "公开动态", value: 0},
        {label: "私密动态", value: 1}
      ],
      reveal: 0,

      typeArray: [
        {label: "不限", value: -1},
        {label: "相册动态", value: 2},
        {label: "匿名动态", value: 3},
        {label: "普通动态", value: 1}
      ],
      type: 1,

      stateArray: [
        {label: "不限", value: -1},
        {label: "待审核", value: 0},
        {label: "已通过", value: 1},
        {label: "不通过", value: 2},
        {label: "仅发布者可见", value: 3}
      ],
      state: 0,

      resumeStateArray: [
        {label: "不限", value: -1},
        {label: "未查看", value: 0},
        {label: "待审核", value: 1},
        {label: "已通过", value: 2},
        {label: "不通过", value: 3}
      ],
      resumeState: -1,

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,

      //置顶状态
      topStateArray: [
        {label: "不限", value: -1},
        {label: "未置顶", value: 0},
        {label: "待置顶", value: 1},
        {label: "已置顶", value: 2},
        {label: "已过期", value: 3}
      ],
      topState: -1,

      //删除
      isDelArray: [
        {label: '不限', value: -1},
        {label: '未删除', value: 0},
        {label: '已删除', value: 1},
      ],
      isDel: 0,

      //隐藏用户
      hideStateArray: [
        {label: "不限", value: -1},
        {label: "未隐藏用户", value: 0},
        {label: "隐藏用户", value: 1}
      ],
      hideState: 0,

      //优质动态
      qualityStateArray: [
        {label: "不限", value: -1},
        {label: "未设置优质", value: 0},
        {label: "已设置优质", value: 1},
        {label: "已取消优质（系统）", value: 2},
        {label: "已取消优质（用户）", value: 3}
      ],
      qualityState: -1,

      //异常用户
      abnormalStateArray: [
        {label: "不限", value: -1},
        {label: "正常用户", value: 0},
        {label: "异常用户", value: 1}
      ],
      abnormalState: -1,

      //关注类型
      focusStateArray: [
        {label: '不限', value: -1},
        {label: '未关注', value: 0},
        {label: '已关注', value: 1},
        {label: '自动取消关注', value: 2},
        {label: '手动取消关注', value: 3},
        {label: '已关注-封号', value: 4},
        {label: '已关注-手动', value: 5},
        {label: '已关注-设备异常', value: 6},
        {label: '已关注-IP异常', value: 7},
        {label: '已关注-订单异常', value: 8},
        {label: '已关注-省份不一致', value: 9},
      ],
      focusState: -1,


      //时间
      startTime: '',
      endTime: '',

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '动态内容', value : 4},
      ],
      searchType: '',
      searchValue: '',
      isChecked: true,

      //刷新组
      colList: ['时间', '动态序号', '头像', '用户信息', '内容', '图片', '视频', '用户状态', '类型', '动态状态', '用户日志', '话题', '置顶'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,
      focusLoading: false,


      idArray: [],
      userIdArray: [],
      batchLoading: false,
      updateLoading: false

    }
  },
  methods: {

    rowKey (row) {
      return row.id;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = 0;
      this.resumeState = -1;
      this.sex = -1;
      this.reveal = 0;
      this.type = 1;
      this.topState = -1;
      this.qualityState = -1;
      this.abnormalState = -1;
      this.isDel = 0;
      this.hideState = 0;
      this.searchValue = '';
      this.focusState = -1;
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
      this.userIdArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessageChat,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.$refs.multipleTableRef.clearSelection();
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['type'] = this.type;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['topState'] = this.topState;
      param['sex'] = this.sex;
      param['reveal'] = this.reveal;
      param['resumeState'] = this.resumeState;
      param['isDel'] = this.isDel;
      param['hideState'] = this.hideState;
      param['qualityState'] = this.qualityState;
      param['abnormalState'] = this.abnormalState;
      param['focusState'] = this.focusState;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getZonePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }
    },

    batchUpdate(state) {
      if(this.idArray.length > 0) {
        let _this = this
        this.$confirm('确定批量'+ (state == 1?'通过':state == 3?'仅作者可见': state == 2?'不通过': '') + '选中的动态？').then(() => {
          this.batchLoading = true
          let param = {}
          param['idArr'] = this.idArray;
          param['state'] = state;
          param['awardState'] = 0;
          postFormData(updateZoneState, param).then((data) => {
            let {msg, code } = data;
            if (code == 200) {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'success'
              })
              for(let j=0;j<_this.idArray.length;j++){
                for(let i=0;i<_this.pageDataList.length;i++) {
                  if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                    _this.pageDataList.splice(i,1);
                    i--;
                  }
                }
              }
              if(_this.pageDataList.length == 0){
                _this.getPage();
              }else {
                _this.$refs.multipleTableRef.clearSelection();
              }
            } else {
              this.$message({
                showClose: true,
                duration: 1000,
                message: msg,
                type: 'warning'
              })
            }
            this.batchLoading = false;
          })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
      }
    },

    batchPassUpdate() {
      if (this.idArray.length > 0) {
        let _this = this
        Dialog.open({
          title: '确定批量通过选中的动态？',
          component: BatchPassDialog,
          data: {
            idArray: _this.idArray,
            width: '500px'
          },
          confirm: (result) => {
            for(let j=0;j<_this.idArray.length;j++){
              for(let i=0;i<_this.pageDataList.length;i++) {
                if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
                  _this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(_this.pageDataList.length == 0){
              _this.getPage();
            }else {
              _this.$refs.multipleTableRef.clearSelection();
            }
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行操作',
          type: 'warning'
        })
      }
    },

    //设为优质
    batchUpdateQuality(state) {
      if (this.idArray.length > 0) {
        if(state == 1) {
          Dialog.open({
            title: '确认批量设为优质状态',
            component: SetQualityDialog,
            data: {
              idArray: this.idArray,
              width: '500px'
            },
            confirm: (result) => {
              this.getPage();
            }
          })
        }else {
          this.$confirm('确认批量取消优质状态？').then(() => {
            this.updateLoading = true;
            let _this = this;
            let param = {};
            param['idArr'] = this.idArray;
            param['qualityState'] = state;
            postFormData(updateQualityZoneState, param).then(function (data) {
              let {code, msg} = data;
              if (code == 200) {
                _this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'success'
                });
                _this.getPage();
              }
              if (code != 1) {
                _this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'warning'
                });
              }
              _this.updateLoading = false;
            })
                .catch(function (response) {
                  _this.updateLoading = false;
                })
          })
              .catch(() => {
              })
        }
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行操作',
          type: 'warning'
        })
      }
    },

    delImg(id, zoneIndex, index) {
      let _this = this;
      this.$confirm('确定要删除图片？', {type: 'warning'}).then(() => {
        let param = {};
        param['id'] = id;
        param['zoneId'] = _this.pageDataList[zoneIndex]['id'];
        postFormData(updateZoneImgDel, param).then((data) => {
          let {code, msg} = data;
          if (code == 200) {
            _this.pageDataList[zoneIndex]['zoneImgList'].splice(index, 1);
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
        })
      }).catch(() => {
      })
    },

    // 置顶设置
    setTop(row, idx) {
      let zoneForm = Object.assign({}, row);
      Dialog.open({
        title: '',
        component: ZoneSetTopDialog,
        data: {
          zoneForm: zoneForm,
          width: '600px'
        },
        confirm: (result) => {
          this.getPage();
        }
      })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList
      })
    },

    showZoneImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },

    onPlay(id) {
      Dialog.open({
        title: '视频播放',
        component: VideoPlay,
        data: {
          videoId: id,
        }
      })
    },

    //设为关注
    updateFocusState(state) {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
        return false
      }
      this.$confirm('确定批量设置为' + (state==5?'【关注用户】':'【不关注用户】') + '?').then(()=>{
        this.focusLoading = true
        let param = {}
        param['idArr'] = this.userIdArray
        param['focusState'] = state
        postFormData(updateResumeFocusState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.focusLoading = false
        }).catch(()=>{
          this.focusLoading = false
        })
      })
    },

  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
.playBtn {
  color: #c0c4cc;
  cursor: pointer;
}
.playBtn:hover {
  color: #409eff;
}
.imgItem {
  position: relative;
}
.closeBtn {
  width: 2em;
  height: 2em;
  background-color: rgba(0,0,0,0.8);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0.6em;
}
</style>
